import axios from 'axios'
import Cookies from 'js-cookie'
import store from '@/store'
import router from '@/router'
import App from '@/main'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 3600000
})

service.interceptors.request.use(
    config => {
        const token = Cookies.get('token')
        if (token) {
            config.headers = Object.assign({}, config.headers, {
                'Authorization': `Bearer ${token}`
            })
        }

        return config
    },
    error => Promise.reject(error)
)

service.interceptors.response.use(
    res => Promise.resolve(res),
    err => {
        if (err.response && err.response.status == 401 && !['/', '/login'].includes(App.$route.path)) {
            store.commit('SET_USER', null)
            store.commit('REMOVE_TOKEN')

            store.dispatch('addMessage', {
                type: 'error',
                message: 'autologout',
                time: 4000
            })

            router.push('/login')
        }

        return Promise.reject(err)
    }
)

export default service
